module.exports = __webpack_public_path__ + "media/icons/check@2x-536abc0c.png";